import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #141416 0%, #1f1f23 50%, #161618 100%)' }}>
      <div className="max-w-md w-full mx-4">
        <div className="bg-gradient-to-br from-zinc-900 to-zinc-950 rounded-2xl border border-zinc-800 p-8 text-center">
          <div className="w-16 h-16 rounded-full bg-yellow-500/10 border border-yellow-500/30 flex items-center justify-center mx-auto mb-4">
            <span className="text-yellow-500 text-3xl">!</span>
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Payment Cancelled</h2>
          <p className="text-zinc-400 mb-6">
            No charges were made. Your payment link is still valid—you can complete payment anytime from the email we sent you to confirm your appointment.
          </p>
          <div className="flex gap-4">
            <Button 
              onClick={() => navigate('/')}
              className="flex-1 bg-orange-500 hover:bg-orange-600 text-white"
            >
              Go Home
            </Button>
            <Button 
              onClick={() => navigate('/contact')}
              variant="outline"
              className="flex-1 border-zinc-700 text-zinc-300 hover:bg-zinc-800"
            >
              Contact Us
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
